import React from 'react'
import PropTypes from 'prop-types'
import Button from '../components/button'
import DotTextSeperator from '../components/dot_text_seperator'
import Icon from '../components/icon'
import Text from '../components/text'

class SortBlock extends React.PureComponent {

  handleOnClickValue = () => {
    if (!!this.props.onClickValue) this.props.onClickValue(this.valueBtn)
  }
  handleOnClickSubValue = () => {
    if (!!this.props.onClickSubValue) this.props.onClickSubValue(this.subValueBtn)
  }
  setValueBtnRef = e => this.valueBtn = e
  setSubValueBtnRef = e => this.subValueBtn = e

  render() {
    const { value, subValue, title } = this.props

    return (
      <div className={[_s.d, _s.px5, _s.pb15, _s.flexRow].join(' ')}>
        <Text color='secondary' size='small'>
          {title}
        </Text>
        <Button
          isText
          backgroundColor='none'
          color='secondary'
          className={[_s.flexRow, _s.aiCenter].join(' ')}
          buttonRef={this.setValueBtnRef}
          onClick={this.handleOnClickValue}
        >
          <Text color='inherit' weight='medium' size='small'>
            &nbsp;{value}&nbsp;
          </Text>
          <Icon id='caret-down' size='6px' className={_s.cSecondary} />
        </Button>

        {
          !!subValue &&
          <React.Fragment>
            <div className={[_s.d, _s.flexRow, _s.px5].join(' ')}>
              &nbsp;<DotTextSeperator />&nbsp;
            </div>

            <Button
              isText
              backgroundColor='none'
              color='secondary'
              className={[_s.flexRow, _s.aiCenter].join(' ')}
              buttonRef={this.setSubValueBtnRef}
              onClick={this.handleOnClickSubValue}
            >
              <Text color='inherit' weight='medium' size='small'>
                {subValue}&nbsp;
              </Text>
              <Icon id='caret-down' size='6px' className={_s.cSecondary} />
            </Button>
          </React.Fragment>
        }
      </div>
    )
  }

}

SortBlock.defaultProps = {
  title: 'Sort by',
}

SortBlock.propTypes = {
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  subValue: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  onClickValue: PropTypes.func.isRequired,
  onClickSubValue: PropTypes.func,
}

export default SortBlock
